import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * Fires a GA4 page_view event with the ACTUAL page title (set by react-helmet-async via the
 * <SEO> component) on every route change. GA4's default auto page_view (fired once at initial
 * load, before gtag.js knows about client-side navigation) always reports the same generic
 * title for every route in a SPA - this hook fixes that so each page shows up distinctly in
 * Analytics > Engagement > Pages and screens.
 *
 * Requires `gtag('config', GA_ID, { send_page_view: false })` in index.html to disable the
 * automatic page_view (see public/index.html), since we send it manually here instead.
 */
export function usePageViewTracking() {
  const location = useLocation();

  useEffect(() => {
    // Small delay so react-helmet-async has committed the new <title> to the DOM before we read it
    const timer = setTimeout(() => {
      if (typeof window.gtag === "function") {
        window.gtag("event", "page_view", {
          page_title: document.title,
          page_location: window.location.href,
          page_path: location.pathname + location.search,
        });
      }
    }, 80);
    return () => clearTimeout(timer);
  }, [location.pathname, location.search]);
}
